/**
 * 사용자 차단 기능 노출 여부.
 * 차단 스펙("메시지를 나에게만 숨김, 상대 비공지")과 달리 알림/푸시/배지에는
 * 차단 필터가 미구현이라(QA-03/04) 파이프라인 정비 전까지 기능 전체를 비표시.
 * 재노출 시 이 플래그만 true 로 변경.
 */
export const FEATURE_USER_BLOCKING = false;
